import React from 'react';
import ServicesGrid from '../components/ServicesGrid';
import HowItWorks from '../components/HowItWorks';
import { getWhatsAppUrl } from '../config/constants';
import usePageTitle from '../hooks/usePageTitle';
import './Services.css';

function Services() {
  usePageTitle('Servicios');

  return (
    <div className="services-page">
      <div className="services-hero">
        <div className="services-hero-content">
          <h1>Nuestros Servicios</h1>
          <p>
            Ofrecemos la mejor experiencia en video 360° para todo tipo de
            eventos. ¡Haz que tu celebración sea inolvidable!
          </p>
        </div>
      </div>

      <div className="container">
        <section className="package-details section">
          <div className="package-card card">
            <h2>Paquete Cab360</h2>
            <p className="package-subtitle">
              Ideal para eventos de 60 a 100 personas
            </p>

            <div className="package-content">
              <div className="package-features">
                <h3>¿Qué incluye?</h3>
                <ul>
                  <li>
                    <i className="fas fa-check"></i> Plataforma giratoria 360°,
                    capacidad máxima 3 personas por video
                  </li>
                  <li>
                    <i className="fas fa-check"></i> Servicio de video por 3
                    horas
                  </li>
                  <li>
                    <i className="fas fa-check"></i> Iluminación ambiental
                    profesional
                  </li>
                  <li>
                    <i className="fas fa-check"></i> Accesorios para videos
                    (props divertidos)
                  </li>
                  <li>
                    <i className="fas fa-check"></i> 2 personas de staff durante
                    el evento
                  </li>
                  <li>
                    <i className="fas fa-check"></i> Sorpresas especiales para
                    tus invitados
                  </li>
                </ul>
              </div>

              <div className="package-pricing">
                <div className="price-card">
                  <h4>Evento completo</h4>
                  <div className="price">
                    $3,500 <span>MXN</span>
                  </div>
                </div>
                <div className="price-card">
                  <h4>Por hora</h4>
                  <div className="price">
                    $1,750 <span>MXN</span>
                  </div>
                </div>
              </div>
            </div>

            <div className="package-benefits">
              <div className="benefit">
                <i className="fas fa-bolt"></i>
                <span>Entrega digital en 5 minutos vía QR</span>
              </div>
              <div className="benefit">
                <i className="fas fa-calendar-alt"></i>
                <span>Acceso a videos por 30 días</span>
              </div>
              <div className="benefit">
                <i className="fas fa-palette"></i>
                <span>Personalización total</span>
              </div>
              <div className="benefit">
                <i className="fas fa-heart"></i>
                <span>Atención personalizada</span>
              </div>
            </div>

            <div className="package-note">
              <h3><strong>Nota:</strong></h3>
              <ul>
                <li>Se aparta la fecha con $500 pesos no reembolsables en caso de cancelación.</li>
                <li>El servicio por hora se contrata como mínimo de 2 horas x evento.</li>
              </ul>
            </div>

            <button
              className="btn btn-primary btn-glow package-btn"
              onClick={() => {
                window.open(
                  getWhatsAppUrl('¡Hola! Me interesa el Paquete Básico para mi evento'),
                  '_blank'
                );
              }}
            >
              ¡Quiero este paquete!
            </button>
          </div>
        </section>
        <ServicesGrid />
        <HowItWorks />
      </div>
    </div>
  );
}

export default Services;
